import { ContentLoading } from '@/components/common/content-loading';
import { useOrientation } from '@/hooks';
import { useFloorGuideStore } from '@/stores/floorGuideStore';
import { lazy, Suspense, useEffect } from 'react';

const HorizontalLazy = lazy(() => import(/* webpackChunkName: "horizontal-view" */ '@/components/feature/floor-guide/horizontal-view'));
const VerticalLazy = lazy(() => import(/* webpackChunkName: "vertical-view" */ '@/components/feature/floor-guide/vertical-view'));

export default function FloorGuidePage() {
    const { isHorizontal } = useOrientation();
    const { resetSelectedPoi, resetFloorGuideType, resetSelectedParkingSlot } = useFloorGuideStore();

    useEffect(() => {
        return () => {
            resetSelectedPoi();
            resetFloorGuideType();
            resetSelectedParkingSlot();
        };
    }, [resetSelectedPoi, resetFloorGuideType, resetSelectedParkingSlot]);

    return (
        <main className="relative h-full w-full overflow-hidden">
            <Suspense fallback={<ContentLoading loading />}>{isHorizontal ? <HorizontalLazy key="horizontal" /> : <VerticalLazy key="vertical" />}</Suspense>
        </main>
    );
}
